import React from 'react';
import localize from '../localize';
import NavLinkScrollTop from '../NavLinkScrollTop'

require('./AppHeader.css');

const scrollPos = () => {
  if (window.scrollY || window.scrollY === 0) {
    return window.scrollY
  } else {
    return window.pageYOffset
  }
}

const thresh = () => {
  if (document.body.style && document.body.style.marginTop && document.body.style.marginTop !== '') {
    return parseInt(document.body.style.marginTop, 10)
  } else {
    return 52
  }
}

class AppHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {hidden: scrollPos() <= thresh()}
    this.hideBar = this.hideBar.bind(this)
  }

  hideBar() {
    this.setState({hidden: scrollPos() <= thresh()})
  }

  componentDidMount() {
    window.addEventListener('scroll', this.hideBar)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.hideBar)
  }

  render() {
		return (
      <div>
				<header className="appHeader">
          <table className="centered-content">
            <tbody>
              <tr>
                <th>
                  <NavLinkScrollTop to="/">
  					       <h1><span className="headerText">{this.props.i18n.t('title')}</span></h1>
                  </NavLinkScrollTop>
                </th>
                <th>
  					      {this.props.children}
                </th>
              </tr>
            </tbody>
          </table>
				</header>
				<header className={this.state.hidden? "appHeader staticHeader hiddenHeader" : "appHeader staticHeader"}>
          <table className="centered-content">
            <tbody>
              <tr>
                <th>
                  <NavLinkScrollTop to="/">
                   <h1><span className="headerText">{this.props.i18n.t('title')}</span></h1>
                  </NavLinkScrollTop>
                </th>
                <th>
  					      {this.props.children}
                </th>
              </tr>
            </tbody>
          </table>
				</header>
      </div>
		)
  }
}

export default localize('header')(AppHeader)



// WEBPACK FOOTER //
// ./src/components/AppHeader/index.js